import { createEnrichedDataHook } from '@client/hooks/useBaseEnrichedData';
import { ActiveSubstanceBulkInitializeService } from '../services/bulkInitializeService';
import {
  ACTIVE_SUBSTANCE_FIELD_TO_API,
  ACTIVE_SUBSTANCE_API_TO_ENRICHED,
  ACTIVE_SUBSTANCE_FIELD_TO_ENRICHED,
  ACTIVE_SUBSTANCE_INITIAL_ENRICHED,
} from '@client/config/filterFieldMappings';

/**
 * Enriched data hook for Active Substance search
 * Handles cold start by bulk fetching labels for URL state restoration
 */
export const useActiveSubstanceEnrichedData = createEnrichedDataHook({
  fieldToApiMapping: ACTIVE_SUBSTANCE_FIELD_TO_API,
  apiToEnrichedMapping: ACTIVE_SUBSTANCE_API_TO_ENRICHED,
  fieldToEnrichedMapping: ACTIVE_SUBSTANCE_FIELD_TO_ENRICHED,
  bulkInitialize: (ids) => ActiveSubstanceBulkInitializeService.bulkInitialize(ids),
  initialEnrichedData: ACTIVE_SUBSTANCE_INITIAL_ENRICHED,
  hookName: 'useActiveSubstanceEnrichedData',
});

export default useActiveSubstanceEnrichedData;
